<div class="container">
  @if (userType === 'RP') {
  <div class="pt-2">
    <h1 class="page-title">{{ "Link My Case" }}</h1>
  </div>
  }
  <nh-alert type="danger" [isOpen]="linkCaseService.showError">
    <div class="row">
      <div class="col-auto icon">
        <img
          src="../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
          alt=""
        />
      </div>
      <div class="col message">
        <span
          [innerHTML]="this.linkCaseService.errorMessage | globalTranslate"
        ></span>
      </div>
    </div>
  </nh-alert>
  <nh-alert type="success" [isOpen]="linkCaseService.showSuccess">
    <div class="row">
      <div class="col message">
        <span
          [innerHTML]="this.linkCaseService.errorMessage | globalTranslate"
        ></span>
      </div>
    </div>
  </nh-alert>
  @if (userType === 'RP') {
  <div class="hover-red">
    <a class="hover-red btn btn-link" (click)="onPrevious()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16.875"
        height="15.75"
        viewBox="0 0 16.875 15.75"
      >
        <g
          id="_icons_arrow-back-outline"
          data-name="⚛️ icons/arrow-back-outline"
          transform="translate(0)"
        >
          <path
            id="Combined_Shape"
            data-name="Combined Shape"
            d="M7.093,15.434l-.014-.014L.329,8.671A1.126,1.126,0,0,1,.316,7.093l.014-.014L7.079.329a1.125,1.125,0,0,1,1.6,1.578l-.014.013L3.841,6.75H15.75A1.125,1.125,0,0,1,15.769,9H3.841l4.829,4.829a1.126,1.126,0,0,1,.014,1.578l-.014.013a1.126,1.126,0,0,1-1.578.014Z"
            transform="translate(0)"
            fill="#174a7c"
          />
        </g>
      </svg>
      <span class="ps-2">{{ "BACK_TO_WELCOME_PAGE" | globalTranslate }}</span>
    </a>
  </div>
  }
  <br />

  <div class="container mb-2">
    <div class="row">
      <div class="card flex-card">
        <div class="card-body">
          <section>
            <p>{{ "LINK_CASE_DESC_1" | globalTranslate }}</p>
            <p [innerHTML]="'LINK_CASE_DESC_2_1' | globalTranslate"></p>
            <p aria-hidden="true">{{ "LINK_CASE_DESC_3" | globalTranslate }}</p>
            <p class="visually-hidden">
              {{ "LINK_CASE_DESC_3_1" | globalTranslate }}
            </p>

            <h2 class="section-header">
              {{ "LINK_CASE_DESC_4" | globalTranslate }}
            </h2>
            <hr />
            <p
              class="static-text"
              aria-hidden="true"
              [innerHTML]="'LINK_CASE_DESC_5' | globalTranslate"
            ></p>
            <p
              class="visually-hidden"
              [innerHTML]="'LINK_CASE_DESC_5_1' | globalTranslate"
            ></p>
            <form [formGroup]="caseLinkfrom">
              <div>
                <nh-field
                  label="{{ 'DOB' | globalTranslate }}"
                  class="label-section"
                >
                  <nh-datepicker>
                    <input
                      [attr.aria-label]="'DOB' | globalTranslate"
                      type="text"
                      class="form-control"
                      name="dateOfBirth"
                      formControlName="dateOfBirth"
                      [minDate]="minimumDate"
                      [maxDate]="today"
                      bsDatepicker
                      nh
                      required
                    />
                  </nh-datepicker>
                </nh-field>
                <nh-field
                  label="{{ 'AND' | globalTranslate }}"
                  class="label-section"
                >
                  <select
                    nhTranslate
                    name="and"
                    [attr.aria-label]="'AND' | globalTranslate"
                    [items]="caseLinkItems"
                    formControlName="and"
                    (change)="onValueChange()"
                    required
                  ></select>
                </nh-field>
                @if (selectedItem == 'ssn') {
                <nh-field
                  label="{{ 'SSN' | globalTranslate }}"
                  class="label-section"
                >
                  <input
                    type="text"
                    name="ssn"
                    aria-label="ssn"
                    placeholder="XXX-XX-XXXX"
                    mask="000-00-0000"
                    class="form-control"
                    formControlName="ssn"
                    (change)="ssnValidator()"
                  />
                </nh-field>
                } @if (selectedItem == 'individualId') {
                <nh-field
                  label="{{ 'PID' | globalTranslate }}"
                  class="label-section"
                >
                  <nh-popover
                    field-label
                    class="ml-2 ps-1"
                    [content]="personPop | globalTranslate"
                  ></nh-popover>
                  <input
                    type="text"
                    name="individualId"
                    [attr.aria-label]="'PID' | globalTranslate"
                    mask="9999999999"
                    formControlName="individualId"
                    (input)="checkPersonId()"
                    class="form-control"
                    required
                  />
                </nh-field>
                } @if (selectedItem == 'wpAppNum') {
                <nh-field
                  label="{{ 'APP_NUMBER' | globalTranslate }}"
                  class="label-section"
                >
                  <nh-popover
                    field-label
                    class="ml-2 ps-1"
                    [content]="applicationPop | globalTranslate"
                  ></nh-popover>
                  <input
                    type="text"
                    name="wpAppNum"
                    [attr.aria-label]="'APP_NUMBER' | globalTranslate"
                    formControlName="wpAppNum"
                    (input)="checkValidAppNum()"
                    mask="S00000000"
                    class="form-control"
                    required
                  />
                </nh-field>
                } @if (userType === 'RP') {
                <nh-field
                  label="{{ 'Username or Email Address' }}"
                  class="label-section"
                >
                  <input
                    type="text"
                    name="usernameOrEmail"
                    [attr.aria-label]="
                      'Username or Email Address' | globalTranslate
                    "
                    formControlName="usernameOrEmail"
                    (change)="usernameOrEmail()"
                    class="form-control"
                    required
                  />
                </nh-field>
                }
              </div>
            </form>
            <br />
          </section>
        </div>
      </div>
    </div>
  </div>

  @if (userType === 'RP') {
  <div class="row my-1">
    <div class="col-md-12">
      <div class="row mt-3 text-center py-4">
        <div class="col-2 pe-0">
          <button
            id="continue"
            class="btn d-grid btn-secondary btn-width align-items-center"
            (click)="onSubmit()"
            [disabled]="!isFormValid()"
          >
            {{ "SUBMIT" | globalTranslate }}
          </button>
        </div>
        <div class="col-auto ps-0">
          <button
            id="btn-cancel"
            class="btn btn-block btn-outline-secondary text-capitalize-btn"
            (click)="onPrevious()"
          >
            {{ "CANCEL" | globalTranslate }}
          </button>
        </div>
      </div>
    </div>
  </div>
  }
</div>